import React from "react";
import bigImage from "../../assets/About us/Desktop/Ourjourney1.png"; 


const OurJourney = () => {
  return (
    <section className="py-12 px-6 md:px-[75px] bg-gradient-to-b from-[#FFFFFF] to-[#FFF9F3]">
      <div className="">
        
        {/* Heading & Description */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start mb-10">
          <h2 className="font-garamond-subheading  text-[#2C3075] leading-tight">
            Our Journey
          </h2>
          <p className="font-generalsans-description border-t border-[#2C3075] pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] tracking-normal text-[14px]">
            "Arambh" — a Sanskrit word meaning beginning or initiation — reflects our core
            belief that every individual deserves a fresh start. Founded with the vision of
            creating a space where people can heal without judgment, Arambh Rehab began
            its journey to provide accessible, personalized, and holistic recovery solutions.
            Over the years, we have helped countless individuals and their families overcome
            the impact of addiction and mental health issues, empowering them to rebuild
            their lives with strength and dignity.
          </p>
        </div>

        {/* Big image row */}
        <div className="flex justify-end w-full mx-auto mb-6">
          <img
            src={bigImage}
            alt="Our Journey Main"
            className="w-full md:w-4/5 rounded-[20px] object-cover"
          />
        </div>

        {/* Small image row */}
        {/* <div className="flex justify-center md:justify-start">
          <img
            src={smallImage}
            alt="Our Journey Secondary"
            className="w-full md:w-2/5 rounded-[20px] object-cover"
          />
        </div> */}

      </div>
    </section>
  );
};

export default OurJourney;
